<div
  class="meter-container"
  [ngClass]="{ 'empty-meter': !meters() }"
>
  @for (asset of meters(); track asset; let i = $index; let c = $count) {
    <div
      [style.width]="asset.percent + '%'"
      [style.background-color]="asset.color"
    ></div>
  }
</div>

<div class="mt-medium asset-titles">
  @for (asset of meters(); track asset) {
    @if (asset.percent) {
      <div class="d-flex flex-row align-items-center">
        <span
          class="meter-color"
          [style.background-color]="asset.color"
        ></span>
        <span class="title-meter"> {{ asset.title }} - {{ (asset.percent | number: '1.0-1') + ' %' }} </span>
      </div>
    }
  }
</div>
